import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';

import Modal from 'components/ui/Modal';
import { ActionButton } from 'components/ui/Button';
import TicketOptions from './TicketOptions';
import { StyledWarningMessage } from './GenerateTickets.styles';

const GenerateTickets = ({
  alert,
  bookingReference,
  disabled,
  isOpen,
  loading,
  onPress,
  onSelect,
  onToggle,
  passengerLastName,
  selectedMethod,
  allowedMethods,
  passengerEmails,
  selectedEmails,
  setSelectedEmails,
  hasNonEurostarExpiredTickets = false,
  hasSNCBTicketsUnavailable = false
}) => (
  <>
    <ActionButton disabled={disabled} data-cy="issue-tickets" onClick={onToggle}>
      <FormattedMessage id="manageBooking.issueTickets" />
    </ActionButton>
    <Modal
      alert={alert}
      isOpen={isOpen}
      title={<FormattedMessage id="issueTickets.title" />}
      subtitle={
        hasNonEurostarExpiredTickets ? (
          <StyledWarningMessage>
            <FormattedMessage id="issueTickets.subtitleExpiredExternalTickets" />
          </StyledWarningMessage>
        ) : (
          <FormattedMessage id="issueTickets.subtitle" />
        )
      }
      onClose={onToggle}
      bottomRow={
        <ActionButton
          disabled={hasSNCBTicketsUnavailable}
          loading={loading}
          data-cy="issue-tickets-action"
          onClick={onPress}
          variant="primary"
        >
          <FormattedMessage id="issueTickets.submit" />
        </ActionButton>
      }
    >
      <TicketOptions
        bookingReference={bookingReference}
        passengerLastName={passengerLastName}
        selectedMethod={selectedMethod}
        setSelectedMethod={onSelect}
        allowedMethods={allowedMethods}
        passengerEmails={passengerEmails}
        selectedEmails={selectedEmails}
        setSelectedEmails={setSelectedEmails}
        hasSNCBTicketsUnavailable={hasSNCBTicketsUnavailable}
      />
    </Modal>
  </>
);

GenerateTickets.propTypes = {
  alert: PropTypes.node,
  bookingReference: PropTypes.string.isRequired,
  disabled: PropTypes.bool,
  isOpen: PropTypes.bool,
  loading: PropTypes.bool,
  onPress: PropTypes.func,
  onSelect: PropTypes.func,
  onToggle: PropTypes.func,
  passengerLastName: PropTypes.string.isRequired,
  selectedMethod: PropTypes.string,
  allowedMethods: PropTypes.arrayOf(PropTypes.string),
  passengerEmails: PropTypes.arrayOf(PropTypes.string).isRequired,
  selectedEmails: PropTypes.arrayOf(PropTypes.string).isRequired,
  setSelectedEmails: PropTypes.func.isRequired,
  hasNonEurostarExpiredTickets: PropTypes.bool,
  hasSNCBTicketsUnavailable: PropTypes.bool
};

GenerateTickets.defaultProps = {
  disabled: false,
  loading: false,
  isOpen: false
};

export default GenerateTickets;
